const newUserAppUrls = {
  development: 'http://localhost:3005',
  staging: 'https://staging-member.goboon.co',
  production: 'https://member.goboon.co',
  demo: 'https://demo-member.goboon.co',
};

const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
const newUserAppUrl = newUserAppUrls[environment];

export default newUserAppUrl;
